import {MessageViewModel} from '../../viewmodel/MessageViewModel';

export abstract class MessageComponent {

    // Both are set by BotatoChatMessageComponent right after the component is created
    public messageInternal!: MessageViewModel;
    protected componentRenderingCompleted!: () => void;

    public get message(): MessageViewModel {
        return this.messageInternal;
    }

    public set message(value: MessageViewModel) {
        this.messageInternal = value;
        this.onMessageSet(value);
    }

    public registerRenderingCompletedCallback(callback: () => void): void {
        this.componentRenderingCompleted = callback;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected onMessageSet(value: MessageViewModel): void {
        // Method can be overriden by other classes
    }

    // Called when user sent any message to the backend
    public onAnyMessageSent(): void {
        // Method can be overriden by other classes
    }


    // Called when user sent any event to the backend
    public onAnyEventSent(): void {
        // Method can be overriden by other classes
    }
}

